export default __webpack_public_path__ + "static/media/37.ef72204b.svg";